import { isAnyArray } from 'is-any-array';
function sequentialFill(input, options = {}) {
    if (!isAnyArray(input)) {
        if (typeof input === 'object') {
            options = input ?? {};
        }
        input = [];
    }
    if (!isAnyArray(input)) {
        throw new TypeError('input must be an array');
    }
    let { from = 0, size = input.length, step } = options;
    const { to = 10 } = options;
    if (size !== 0 && step) {
        throw new Error('step is defined by the array size');
    }
    if (!size) {
        if (step) {
            size = Math.floor((to - from) / step) + 1;
        }
        else {
            size = to - from + 1;
        }
    }
    if (!step && size) {
        step = (to - from) / (size - 1);
    }
    if (typeof step !== 'number') {
        throw new TypeError('No checks initialized the step');
    }
    if (Array.isArray(input)) {
        // only works with normal array
        input.length = 0;
        for (let i = 0; i < size; i++) {
            input.push(from);
            from += step;
        }
    }
    else {
        if (input.length !== size) {
            throw new Error('sequentialFill typed array must have the correct length');
        }
        for (let i = 0; i < size; i++) {
            input[i] = from;
            from += step;
        }
    }
    return input;
}
export default sequentialFill;
//# sourceMappingURL=index.js.map